<script setup>
import { ref, provide, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const authRoutes = ['Login', 'Signup', 'ForgotPassword', 'ResetPassword', 'ResetPasswordQuery', 'InviteLanding', 'Terms', 'PublicTrip'];
const isAuthPage = computed(() => authRoutes.includes(route.name));

// Signed-in pages that bring their own top bar (the guided verification flow).
const focusRoutes = ['VerifyFlow'];
const isFocusPage = computed(() => focusRoutes.includes(route.name));

const mapRoutes = ['NewRequest', 'TrackOrder', 'PublicTrip'];
const isMapPage = computed(() => mapRoutes.includes(route.name));
</script>

<!-- Tawk.to customer support intentionally disabled -->

<template>
  <el-config-provider namespace="ep">
    <template v-if="isAuthPage">
      <router-view></router-view>
    </template>
    <div v-else-if="isFocusPage" class="focus-container">
      <router-view></router-view>
    </div>
    <template v-else>
      <BaseHeader />
      <div class="main-container" :class="isMapPage ? 'main-container--map' : 'main-container--page'">
        <!-- out-in, not the default simultaneous mode: NewRequest and
             TrackOrder each mount their own GMapMap, and overlapping them
             would put two Maps instances on the page at once. The fade-out is
             deliberately much shorter than the fade-in, and TrackOrder paints
             a skeleton immediately, so the gap reads as the panel changing
             rather than the page blanking. -->
        <router-view v-slot="{ Component }">
          <Transition name="xo-view" mode="out-in">
            <component :is="Component" />
          </Transition>
        </router-view>
      </div>
    </template>
  </el-config-provider>
</template>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

#app {
  color: var(--ep-text-color-primary);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main-container--map {
  position: relative;
  flex: 1;
  overflow: hidden;
  width: 100%;
}

.focus-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

.main-container--page {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

/* Route transition. Asymmetric on purpose — leave fast so the old view does
   not linger, arrive slower so the new one settles. */
.xo-view-leave-active { transition: opacity 120ms ease-in; }
.xo-view-enter-active { transition: opacity 240ms ease-out, transform 240ms cubic-bezier(.2,.8,.3,1); }
.xo-view-leave-to { opacity: 0; }
.xo-view-enter-from { opacity: 0; transform: scale(0.994); }

@media (prefers-reduced-motion: reduce) {
  .xo-view-leave-active, .xo-view-enter-active { transition-duration: 1ms; }
  .xo-view-enter-from { transform: none; }
}
</style>